module.exports = __webpack_public_path__ + "img/_icon_logout.33e11519.svg";